// ** Reactstrap Imports
import { Badge } from 'reactstrap';

const statusObj = {
  activo: 'light-success',
  inactivo: 'light-secondary'
};

const renderType = (row) => {
  const typeColor = {
    FREE: {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Free'
    },
    PREMIUM: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Premium'
    },
    FREEMIUM: {
      primary: '#14E4ED',
      secondary: '#FFEBF9',
      text: 'Freemium'
    }
  };

  const Div = () => (
    <div
      style={{
        color: typeColor[row.membership].primary,
        background: `${
          typeColor[row.membership].secondary
        } 0% 0% no-repeat padding-box`,
        padding: '2.5px 16px',
        borderRadius: '11px',
        fontWeight: 'bold'
      }}
    >
      {typeColor[row.membership].text}
    </div>
  );

  return (
    <span className="text-left">
      <Div />
    </span>
  );
};

export const columns = [
  {
    name: 'RANKING',
    sortable: false,
    minWidth: '20px',
    center: true,
    sortField: 'rank',
    selector: (row) => row.rank,
    cell: (row, idx) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{idx + 1}</span>
        </div>
      </div>
    )
  },
  {
    name: 'PORTADA',
    sortable: false,
    minWidth: '10px',
    selector: (row) => row.cover,
    cell: (row) => <img width={45} height={45} src={row.cover} />
  },
  {
    name: 'NOMBRE',
    sortable: false,
    minWidth: '180px',
    sortField: 'name',
    selector: (row) => row.name,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.name}</span>
        </div>
      </div>
    )
  },
  {
    name: 'EPISODIOS',
    minWidth: '120px',
    center: true,
    selector: (row) => row.episodes,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.episodes.length}
      </span>
    )
  },
  {
    name: 'ME GUSTA',
    minWidth: '120px',
    center: true,
    selector: (row) => row.likes,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.likes}
      </span>
    )
  },
  {
    name: 'EMPEZADO',
    minWidth: '120px',
    center: true,
    selector: (row) => row.started,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.started}
      </span>
    )
  },
  {
    name: 'PORCENTAJE',
    minWidth: '150px',
    sortable: false,
    selector: (row) => row.started,
    cell: (row) => (
      <div className="progress" style={{ width: '100%', height: 7 }}>
        <div
          id={row._id}
          className="progress-bar"
          role="progressbar"
          style={{
            background: '#4DFF84',
            width: row.started ? `${(row.finished / row.started) * 100}%` : '0%'
          }}
          aria-valuenow={row.started || 0}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    )
  },
  {
    name: 'COMPLETADO',
    minWidth: '150px',
    center: true,
    selector: (row) => row.finished,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.finished}
      </span>
    )
  },
  {
    name: 'MEMBRESIA',
    minWidth: '170px',
    selector: (row) => row.membership,
    cell: (row) => renderType(row)
  },
  {
    name: 'ESTADO',
    minWidth: '120px',
    sortable: false,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.status ? statusObj.activo : statusObj.inactivo}
        pill
      >
        {row.status ? 'Activo' : 'Inactivo'}
      </Badge>
    )
  }
];
